module.exports = "<div class=\"container\">\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-md-12 py-4 px-4\">\r\n\t\t\t<div class=\"card py-4 px-4\">\r\n\t\t\t\t<h3>About Us</h3>\r\n\t\t\t\t<div class=\"jumbotron\">\r\n\t\t\t\t\tThis is my own Angular 5 boiler plate\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.html
// module id = ./src/app/about/about.component.html
// module chunks = main